import React from 'react';
import translateService from '../../../common/translateService';
import { isDiscontinued } from '../../../services/product/productService';

import './ProductInfo.scss';

const ProductInfo = (props) => {
    return (
        <>
            {props.isKit && (
                <>
                    {!props.kitAvailable && (
                        <div className='prd-options-kit-availability-note'>
                            <p>
                                {translateService.get(
                                    `productDetail.oneOrMoreComponentUnavailable`
                                )}
                            </p>
                        </div>
                    )}
                    <h2 className='prd-options-kit'>
                        {translateService.get(
                            `productDetail.productKitIncludes`
                        )}
                    </h2>
                </>
            )}
            {isDiscontinued(props.options, props.isKit) && (
                <div className='prd-options-discontinued-availability-note'>
                    <p>
                        {translateService.get(`productDetail.untilDepletion`)}
                    </p>
                </div>
            )}
        </>
    );
};

export default ProductInfo;
